package com.milta.core.localization

/**
 * Strings for the Admin "Utilisateurs" dashboard screen (web-only, Enterprise back-office —
 * see [com.milta.web.AdminUsersContent]). Read-only screen: no create/update/suspend copy exists
 * on purpose.
 */
data class AdminUsersStrings(
    val loading: String,
    val errorNoConnection: String,
    val errorGeneric: String,
    val readOnlyNotice: String,
    val kpiAccountsLabel: String,
    val kpiAccountsSubtitle: String,
    val kpiDriversLabel: String,
    val kpiDriversSubtitle: String,
    val kpiPatronsLabel: String,
    val kpiPatronsOrgSingular: String,
    val kpiPatronsOrgPlural: String,
    val kpiActiveSubsLabel: String,
    val kpiActiveSubsSubtitle: String,
    val kpiAtRiskLabel: String,
    val kpiAtRiskSubtitle: String,
    val searchPlaceholder: String,
    val expandAllAction: String,
    val collapseAllAction: String,
    val columnAccount: String,
    val columnContact: String,
    val columnType: String,
    val columnAddedDate: String,
    val columnSubscription: String,
    val columnSince: String,
    val columnRenewal: String,
    val noOrganizationHeader: String,
    val emptySearchResult: String,
    /** "Patron" badge prefix — composed in code as "$patronBadgePrefix + $count 👤". */
    val patronBadgePrefix: String,
    /** Composed in code as "$createdOnPrefix ${formatDate(...)}". */
    val createdOnPrefix: String,
    val emptyTeamMessage: String,
    val driverBadge: String,
    /** Composed in code as "$addedOnPrefix ${formatDate(...)}". */
    val addedOnPrefix: String,
    val viaOrganization: String,
    val accountCreatedOnUnknown: String,
    /** Composed in code as "${count}× ${if (count == 1) renewalSingular else renewalPlural}". */
    val renewalSingular: String,
    val renewalPlural: String,
    val subscriptionNone: String,
    val subscriptionActive: String,
    val subscriptionTrial: String,
    val subscriptionGrace: String,
    val subscriptionExpiredStatus: String,
    val subscriptionCancelled: String,
    val planOrganization: String,
    val planDriver: String,
)
